import Vue from 'vue'
import Router from 'vue-router'

// pages
import Top from '@/components/pages/Top.vue'
import Room from '@/components/pages/Room.vue'

// errors
import NotFound from '@/components/pages/errors/NotFound.vue'

Vue.use(Router)

const routes = [
  { path: '/', name: 'top', component: Top },
  { path: '/:roomName', name: 'room', component: Room },
  { path: '*', name: 'notFound', component: NotFound }
]

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

export default router
